import { ChipProps } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Icon } from "#shared/icons/Icon";
import classes from "#shared/view/components/chipTruncate.module.css";
import { EllipsisTooltip } from "#shared/view/components/EditableTable/EllipsisTooltip";
import { Chip } from "#shared/view/designSystem/Chip";
import { MaterialGradeType } from "shared";

type Props = {
  materialGrade: MaterialGradeType | null;
} & Partial<ChipProps>;

function MaterialChip({ materialGrade, ...props }: Props) {
  const { t } = useTranslation();
  const text = materialGrade
    ? t(`qrl.materialGrades.${materialGrade}`).toLocaleLowerCase()
    : t("qrl.materialGrades.OTHER").toLocaleLowerCase();

  return (
    <Chip
      size="xs"
      icon={<Icon name="layer" size={12} />}
      checked
      color="yellow.3"
      autoContrast
      classNames={{ label: classes.label }}
      {...props}
    >
      <EllipsisTooltip content={text} />
    </Chip>
  );
}

export default MaterialChip;
